import { useEffect, useCallback, useState } from 'react';

/**
 * Custom hook for infinite scroll functionality using page/window scroll
 * @param {Function} loadMore - Function to call when more data needs to be loaded
 * @param {boolean} hasNextPage - Whether there are more pages to load
 * @param {boolean} isLoading - Whether data is currently being loaded
 * @param {number} threshold - Distance from bottom to trigger load (default: 100px)
 * @returns {Object} - { isLoadingMore }
 */
const usePageInfiniteScroll = (loadMore, hasNextPage, isLoading, threshold = 100) => {
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const handleScroll = useCallback(() => {
    if (isLoading || !hasNextPage || isLoadingMore) {
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = window.innerHeight;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

    console.log('Page scroll metrics:', {
      scrollTop,
      scrollHeight,
      clientHeight,
      distanceFromBottom,
      threshold
    });

    if (distanceFromBottom < threshold) {
      console.log('Triggering page loadMore...');
      setIsLoadingMore(true);
      loadMore().finally(() => {
        setIsLoadingMore(false);
      });
    }
  }, [loadMore, hasNextPage, isLoading, isLoadingMore, threshold]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return {
    isLoadingMore
  };
};

export default usePageInfiniteScroll;